import { AnimationVariables } from 'office-ui-fabric-react/lib/Styling';
export var PivotStyles = function (props) {
    var theme = props.theme, rootIsTabs = props.rootIsTabs;
    var palette = theme.palette;
    return {
        link: [
            !rootIsTabs && {
                height: 44,
                lineHeight: 44,
                selectors: {
                    ':hover': {
                        backgroundColor: palette.neutralLighter,
                        color: palette.neutralDark,
                    },
                    ':active': {
                        backgroundColor: palette.neutralLight,
                    },
                },
            },
        ],
        linkIsSelected: [
            !rootIsTabs && {
                height: 44,
                lineHeight: 44,
                selectors: {
                    ':hover': {
                        backgroundColor: palette.neutralLighter,
                    },
                    ':active': {
                        backgroundColor: palette.neutralLight,
                    },
                    ':before': {
                        transition: "left " + AnimationVariables.durationValue2 + " " + AnimationVariables.easeFunction2 + ",\n                        right " + AnimationVariables.durationValue2 + " " + AnimationVariables.easeFunction2,
                    },
                    ':hover::before': {
                        left: 0,
                        right: 0,
                    },
                },
            },
        ],
    };
};
//# sourceMappingURL=Pivot.styles.js.map